import React from 'react';
import { observer } from 'mobx-react';
import ConfirmComponent from './Confirm.component';
import useConfirm from './useConfirm';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { state, store, lang, handlers } = useConfirm(onClose);

    return (
        <>
            <ConfirmComponent
                lang={lang.lang}
                loading={store.confirmLoading}
                code={state.code}
                codeError={state.codeError}
                confirmError={store.confirmError}
                serverError={store.serverError}
                isAllowedToRequestAgain={store.isAllowedToRequestAgain}
                sendedAgain={store.sendedAgain}
                timeToRequestAgain={store.timeToRequestAgain}
                onCodeChange={handlers.handleCodeChange}
                onSendClick={handlers.handleSendClick}
                onRequestConfirmClick={handlers.handleRequestConfirmClick}
                onInputClick={handlers.handleInputClick}
                onBackClick={handlers.handleBackClick}
                onKeyDown={handlers.handleKeyDown}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onClose={onClose}
            />
        </>
    );
};

const ConfirmContainer = observer(Container);

export default ConfirmContainer;
